import React, { useRef, useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button1 from "../Buttons/Button1";
import Button2 from "../Buttons/Button2";
import Input from "../Input/Input-main";
import SearchBar22 from "../Input/searchbar";
import SubHeader from "../Subheader/subheader";
import HeaderForm from "./Header2-Form";

const data = [
  {
    id: 2,
    name: "Goa",
  },
  {
    id: 29,
    name: "Kodaikanal",
  },
  {
    id: 21,
    name: "Dhanaulti",
  },
  {
    id: 22,
    name: "Mount Abu",
  },
  {
    id: 3,
    name: "Lonavala",
  },
  {
    id: 4,
    name: "Manali",
  },
  {
    id: 6,
    name: "Khopoli",
  },
  {
    id: 7,
    name: "Mahabaleshwar",
  },
  {
    id: 8,
    name: "Panchgani",
  },
  {
    id: 9,
    name: "Alibag",
  },
  {
    id: 10,
    name: "Pune",
  },
  {
    id: 11,
    name: "Udaipur",
  },
  {
    id: 12,
    name: "Indore",
  },
  {
    id: 13,
    name: "Madikeri",
  },
  {
    id: 14,
    name: "Nashik",
  },
  {
    id: 30,
    name: "Ooty",
  },
  {
    id: 15,
    name: "Neemuch",
  },
  {
    id: 16,
    name: "Palgarh",
  },
  {
    id: 17,
    name: "Uttan",
  },
  {
    id: 24,
    name: "Kasauli",
  },
  {
    id: 20,
    name: "Kamshet",
  },
  {
    id: 25,
    name: "Jaipur",
  },
  {
    id: 31,
    name: "Bengaluru",
  },
  {
    id: 18,
    name: "Mussoorie",
  },
  {
    id: 26,
    name: "Dehradun",
  },
  {
    id: 27,
    name: "Shimla",
  },
  {
    id: 19,
    name: "Raipur",
  },
  {
    id: 23,
    name: "Kanatal",
  },
  {
    id: 5,
    name: "Karjat",
  },
  {
    id: 28,
    name: "Lansdowne",
  },
  {
    id: 1,
    name: "Igatpuri",
  },
];

const Header2 = ({
  setLocationQuery,
  location,
  setLocation,
  adults,
  setAdults,
  children,
  setChildren,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  handleInputSearch,
  handleSearchClick,
}) => {
  const inputDestination = useRef(null);
  const navigate = useNavigate();

  const handleCartClick = () => {
    navigate("/coming-soon");
  };

  // const handleSearchClick = () => {
  //   let destination = location;
  //   let diffTime;
  //   if(typeof(endDate)!=="undefined")
  //    diffTime = Math.abs(endDate.getTime() - startDate.getTime());
  //    else diffTime=0;
  //   const days=Math.floor(diffTime / (1000 * 60 * 60 * 24));
  //   const tempStartDate = startDate?.toISOString().slice(0, 10);
  //   const tempEndDate = endDate?.toISOString().slice(0, 10);
  //   // //console.log("LOCATION updateed", destination, adults, children, tempDate);

  //   let  temp = `city=${destination}&adults=${adults}&children=${children}&startDate=${tempStartDate}&endDate=${tempEndDate}&days=${days}`;

  //   //console.log(temp,"POLS AAGI POLS",days);
  //   setLocationQuery(temp);
  // };

  return (
    <>
      <div className="bg-white flex justify-between shadow-shadowColor shadow-sm z-50 top-0 sticky ">
        <div className="w-[10%] ml-3">
          <img
            src="/a2z-logo.png"
            className="h-[50px] w-[50px] rounded-full object-cover"
            alt="A2Z Villaz"
            className="h-[5vw] hover:cursor-pointer"
            onClick={() => {
              navigate("/");
            }}
          ></img>
        </div>
        {/* <HeaderForm /> */}
        {/* <div class="relative w-1/4 flex flex-row border-black border-[1.5px] rounded-full my-auto">
        <img
          src="/Search.svg"
          onClick={handleDestinationClick}
          className="scale-[0.55] hover:cursor-pointer"
        ></img>
        <input
          ref={inputDestination}
          class="my-2  text-sm w-10/12 text-gray-900 rounded-lg bg-gray-50 bg-none outline-0"
          type="text"
          placeholder="Search Location or Property name"
        />
      </div> */}
        <div className="w-[70%] scale-[0.85] z-[1000]">
          <SearchBar22
            location={location}
            setLocation={setLocation}
            adults={adults}
            setAdults={setAdults}
            children={children}
            setChildren={setChildren}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            handleSearchClick={
              typeof handleInputSearch !== "undefined"
                ? handleInputSearch
                : handleSearchClick
            }
          />
        </div>

        <div className="flex flex-row  justify-center mt-4 w-[20%] ">
          <div
            className="mr-5 hover:cursor-pointer scale-[0.9] "
            onClick={() => {
              handleCartClick();
            }}
          >
            <img src="/cart.svg"></img>
          </div>
          <div className="ml-4">
            <Link to="/signup" className="mr-5 scale-[0.8] md:scale-90">
              <Button1 value="Login/Signup" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header2;
